import React, { useState } from 'react';
import { Mail, Eye, EyeOff, LogIn } from 'lucide-react';
import Reveal from '../../../components/shared/Reveal';
import { EditableText } from '../../components';
import { getIcon } from '../iconMap';

function LoginForm({ data, onChange }) {
  const update = (patch) => onChange && onChange({ ...data, ...patch });
  const [show, setShow] = useState(false);
  const HIcon = data.icon ? getIcon(data.icon) : null;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (data.redirect_url) window.open(data.redirect_url, '_blank');
  };

  return (
    <section className="py-16 bg-white">
      <div className="container-page max-w-xl">
        <Reveal>
          <div className="card-surface p-8 bg-gradient-to-br from-white to-olive-light/30">
            <div className="text-center">
              {HIcon && (
                <div className="mx-auto inline-flex h-16 w-16 rounded-full bg-olive text-white items-center justify-center"><HIcon size={28} /></div>
              )}
              <EditableText value={data.heading} onChange={(t) => update({ heading: t })} as="h3" className="font-display text-2xl mt-4" />
              <EditableText value={data.subheading} onChange={(t) => update({ subheading: t })} as="p" multiline className="text-sm text-ink/60 mt-1" />
            </div>
            <form onSubmit={handleSubmit} className="mt-8 space-y-4">
              <label className="block">
                <EditableText value={data.email_label} onChange={(t) => update({ email_label: t })} as="span" className="text-xs text-ink/70 font-medium" />
                <div className="relative mt-1.5">
                  <Mail size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-ink/40" />
                  <input type="email" required placeholder={data.email_placeholder} className="input-base pl-11" />
                </div>
              </label>
              <label className="block">
                <EditableText value={data.password_label} onChange={(t) => update({ password_label: t })} as="span" className="text-xs text-ink/70 font-medium" />
                <div className="relative mt-1.5">
                  {HIcon ? <HIcon size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-ink/40" /> : null}
                  <input type={show ? 'text' : 'password'} required placeholder={data.password_placeholder} className={`input-base ${HIcon ? 'pl-11' : ''} pr-11`} />
                  <button type="button" onClick={() => setShow(!show)} className="absolute right-4 top-1/2 -translate-y-1/2 text-ink/40 hover:text-olive" aria-label="Toggle password">
                    {show ? <EyeOff size={16} /> : <Eye size={16} />}
                  </button>
                </div>
              </label>
              <div className="flex items-center justify-between text-xs">
                <label className="flex items-center gap-2 text-ink/70"><input type="checkbox" className="accent-olive" /> <EditableText value={data.remember_label} onChange={(t) => update({ remember_label: t })} as="span" /></label>
                <button type="button" className="text-olive hover:text-accent transition"><EditableText value={data.forgot_label} onChange={(t) => update({ forgot_label: t })} as="span" /></button>
              </div>
              <button type="submit" className="btn-primary w-full mt-2"><LogIn size={16} /> <EditableText value={data.submit_label} onChange={(t) => update({ submit_label: t })} as="span" /></button>
            </form>
            <p className="mt-6 text-center text-xs text-ink/60">
              <EditableText value={data.help_text_prefix} onChange={(t) => update({ help_text_prefix: t })} as="span" />
              {' '}
              <a href={data.help_email_href} className="text-olive hover:underline"><EditableText value={data.help_email} onChange={(t) => update({ help_email: t })} as="span" /></a>
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}

export default LoginForm;
